import { FC, ReactNode } from 'react';
import styled from './index.module.scss';

interface IProps {
    icon?: ReactNode;
    title?: string;
    desc?: string;
    id?: string;
}

const Header: FC<IProps> = ({ icon, title, desc, id }) => {
    return (
        <div className={`${styled.Header}`} id={id}>
            {icon && icon}
            {title && <h6 className="title">{title}</h6>}
            {desc && <p className="desc">{desc}</p>}
        </div>
    );
};

export default Header;
